import * as Scrivito from "scrivito"

export const TabWidget = Scrivito.provideWidgetClass("TabWidget", {
  attributes: {
    title: "string",
    content: ["widgetlist", { only: "TextWidget" }]
  }
})
